// extracted by mini-css-extract-plugin
export var transportationsCountCell = "_3a31f5cee6f69092a5c7746d28fe02f7-css";
export var transportationsCountCellUnlockButton = "_865ef0d3a5ec9ce334d81da7fe21b3d5-css";